export enum FertilizationCalculationType {
  Agriculture = 'Agriculture',
  Vegetables = 'Vegetables'
  //   Orchard = 'Orchard',
}
